import { render, staticRenderFns } from "./NTableQueryStyle2.vue?vue&type=template&id=8d0840c0&scoped=true&lang=pug&"
import script from "./NTableQueryStyle2.vue?vue&type=script&lang=js&"
export * from "./NTableQueryStyle2.vue?vue&type=script&lang=js&"
import style0 from "./NTableQueryStyle2.vue?vue&type=style&index=0&id=8d0840c0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0840c0",
  null
  
)

export default component.exports